/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useStateContext } from "contexts/ContextProvider";
import { string, object } from "yup";
import accountService from "services/account-service";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import LoginModal from "modals/login/LoginModal";
// import Logo from "../../assets/images/deped_logo.png";
import LockIcon from "@mui/icons-material/Lock";
import { AccountCircle, Visibility, VisibilityOff } from "@mui/icons-material";
import FeedbackLogo from "../../assets/images/CSM3.jpg";
import HealthcheckLogo from "../../assets/images/DailyHealth.jpg";
import SDOICLogo from "../../assets/images/deped_logo.png";
import RepairLogo from "../../assets/images/Repairs2.jpg";
import MaamMerz from "../../assets/images/MaamMerz.jpeg";
import SDOICBG from "../../assets/images/new-background - low res.png";
import transparencySeal from "../../assets/images/transparency_logo.png";

import "./landing.css";

export default function Landing() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setAuth } = useStateContext();
  const [openDialog, setOpenDialog] = useState(false); // State for dialog
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const [openModal, setOpenModal] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);

  const formik = useFormik({
    initialValues: { username: "", password: "" },

    validationSchema: object().shape({
      username: string().required("Username is Required!"),
      password: string().required("Password is Required!"),
    }),
    onSubmit: () => {
      setLoading(true);
      setError("");

      accountService
        .authenticate(formik?.values)
        .then((res) => {
          console.log(res);

          if (res.valid) {
            setAuth(res?.data);
            navigate("/admin");
            localStorage.setItem("authCSM", JSON.stringify(res?.data));
            console.log(res);
          }
        })
        .catch((err) => {
          let message = "";
          if (err?.response?.status === 404) {
            message = "Invalid Credentials";
          } else if (err?.response?.status === 401) {
            message = err?.response?.data?.error;
          } else {
            message = "Internal Server Error";
          }
          setError(message || err?.message);
          setOpenDialog(true);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleNavigateToFeedback = () => {
    navigate("/");
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setIsPasswordEmpty(event.target.value === "");
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Close dialog
  };

  return (
    <Box
      className="main-container"
      sx={{
        position: "relative",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        p: { xs: 2, sm: 4 },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${MaamMerz})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.3,
          zIndex: 0,
        },
      }}
    >
      <Box sx={{ position: "absolute", top: 30, right: 50 }}>
        <Typography
          variant="body2"
          sx={{
            color: "#333",
            fontWeight: "bold",
            fontSize: { xs: 4, sm: 9, md: 11, lg: 13, xl: 16 },
          }}
        >
          CITIZEN'S CHARTER
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "1200px",
          p: { xs: 2, sm: 4 },
          height: { sm: "70h" },
          width: { sm: "70%" },
        }}
      >
        <Typography
          variant={isSmallScreen ? "h6" : "h4"}
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            mt: 2,
            mb: 2,
            fontFamily: "Poppins",
            fontSize: { sm: 16, md: 21, lg: 24, xl: 36 },
          }}
        >
          WELCOME TO SCHOOLS DIVISION OFFICE OF IMUS CITY
        </Typography>

        <Card
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            width: "100%",
            maxWidth: "1200px",
            height: { sm: "50vh", lg: "65vh" }, // Adjusted height for better layout
            boxShadow: 3,
            // borderRadius: "16px",
            overflow: "hidden",
            "@media (min-width: 1080px) and (min-height: 1920px)": {
              width: "100%",
              maxWidth: "1000px",
              height: "50vh",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              // padding: 6,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              // alignItems: "center",
              alignItems: "center",
              "@media (min-width: 1080px) and (min-height: 1920px)": {
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                textAlign: "center",
              },

              padding: { sm: 2, md: 5, lg: 4, xl: 6 },
            }}
          >
            {/* Logo */}
            <Box
              component="img"
              src={SDOICLogo}
              alt="SDO Imus City Logo"
              sx={{
                width: { sm: "30px", lg: "60px", xl: "90px" },
                marginTop: { sm: 1, lg: -2, xl: 1 },
                mb: { sm: 0.5, xl: 2 },
                "@media (min-width: 1080px) and (min-height: 1920px)": {
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  textAlign: "center",
                },
              }}
            />
            {/* Welcome Text */}
            <Typography
              // variant="h7"
              sx={{
                fontWeight: "bold",
                mb: { sm: 3, xl: 5 },
                fontFamily: "Poppins",
                fontSize: { sm: 9, lg: 21, xl: 21 },
                // justifyContent: "center",
                textAlign: "center",
              }}
            >
              CLIENT SATISFACTION MEASUREMENT SYSTEM (CSM)
            </Typography>
            {/* Username and Password Fields */}
            <form
              onSubmit={formik.handleSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                "@media (min-height: 1920px)": {
                  width: "100%",
                },
                "@media (max-width: 2560px)": {
                  width: "1000px",
                },
                // "@media (min-width: 811px) and (min-height: 647px)": {
                //   width: "800px",
                //   padding: 10,
                // },
              }}
            >
              <TextField
                // fullWidth

                placeholder="Username"
                variant="standard" // Use the "standard" variant for a line style
                sx={{
                  width: { sm: "60%", lg: "120%", xl: "100%" },
                  mb: { sm: 2, xl: 4 },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // Line color before focus
                  },
                  "& .MuiInput-underline:hover:before": {
                    borderBottomColor: "black", // Line color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "blue", // Line color on focus
                  },
                  "& .MuiInputBase-input": {
                    fontSize: { sm: "8px", lg: "12px", xl: "14px" }, // Input text font size
                    fontFamily: "Poppins",
                  },
                  "& .MuiFormHelperText-root": {
                    fontSize: { sm: "8px", lg: "9px", xl: "12px" }, // Smaller font size for error text
                    // fontFamily: "Poppins",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle
                        sx={{
                          fontSize: { sm: 9, lg: 16, xl: 24 },
                          // "@media (min-width: 811px)": {
                          //   fontSize: 12,
                          // },
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                name="username"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.username && Boolean(formik.errors.username)
                }
                helperText={formik.touched.username && formik.errors.username}
              />
              <TextField
                // fullWidth
                placeholder="Password"
                type={showPassword ? "text" : "password"} // Toggle between "text" and "password"
                variant="standard" // Use the "standard" variant for a line style
                sx={{
                  width: { sm: "60%", lg: "120%", xl: "100%" },
                  mb: { sm: 3, xl: 5 },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // Line color before focus
                  },
                  "& .MuiInput-underline:hover:before": {
                    borderBottomColor: "black", // Line color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "blue", // Line color on focus
                  },
                  "& .MuiInputBase-input": {
                    fontSize: { sm: "8px", lg: "12px", xl: "14px" }, // Input text font size
                    fontFamily: "Poppins",
                  },
                  "& .MuiFormHelperText-root": {
                    fontSize: { sm: "8px", lg: "9px", xl: "12px" }, // Smaller font size for error text
                    // fontFamily: "Poppins",
                  },
                  "@media (min-width: 1080px) and (min-height: 1920px)": {
                    mb: 2,
                  },
                  //   "@media (min-width: 811px)": { width: "100%" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon
                        sx={{
                          fontSize: { sm: 9, lg: 16, xl: 24 },
                          // "@media (min-width: 811px)": {
                          //   fontSize: 12,
                          // },
                        }}
                      />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        sx={{
                          fontSize: { sm: 9, lg: 16, xl: 24 },
                          // "@media (min-width: 811px)": {
                          //   fontSize: 12,
                          // },
                        }}
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? (
                          <VisibilityOff
                            sx={{
                              fontSize: { sm: 9, lg: 16, xl: 24 },
                              // "@media (min-width: 811px)": {
                              //   fontSize: 12,
                              // },
                            }}
                          />
                        ) : (
                          <Visibility
                            sx={{
                              fontSize: { sm: 9, lg: 16, xl: 24 },
                              // "@media (min-width: 811px)": {
                              //   fontSize: 12,
                              // },
                            }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
              />
              {/* Login Button */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  padding: { sm: 0.5, lg: 1, xl: 1 },
                  fontSize: { sm: 7, lg: 12, xl: 16 },
                  alignItems: "center",
                  backgroundColor: "#009ddc", // Light Blue
                  "&:hover": {
                    backgroundColor: "#1976d2", // Darker Blue on hover
                  },
                  mb: { sm: 1, xl: 2 },
                  width: { sm: "60%", lg: "120%", xl: "100%" },
                }}
                fullWidth
                disabled={loading}
              >
                LOGIN
              </Button>
              <Button
                onClick={handleNavigateToFeedback}
                variant="contained"
                color="primary"
                sx={{
                  padding: { sm: 0.5, lg: 1, xl: 2 },
                  fontSize: { sm: 7, lg: 12, xl: 16 },
                  alignItems: "center",
                  backgroundColor: "#2a296d", // Light Blue
                  "&:hover": {
                    backgroundColor: "#393b92", // Darker Blue on hover
                  },
                  "@media (min-height: 1920px)": {
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    textAlign: "center",
                  },
                  width: { sm: "60%", lg: "120%", xl: "100%" },
                }}
                fullWidth
              >
                Client Satisfaction Survey
              </Button>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  fontSize: { sm: 6, lg: 11, xl: 12 },
                  "@media (min-width: 1080px) and (min-height: 1920px)": {
                    mb: 10,
                  },
                  width: "200px",
                  mt: { sm: 2, lg: 5 },
                }}
              >
                © DepEd Imus Division | 2025.
              </Typography>
            </form>
          </Box>

          {/* Right Section */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
              "@media (min-height: 1920px)": {
                display: "none", // Hide the right section on 1920px screens
              },
              "@media (min-width: 1366px)": {
                width: "100%",
                height: "100%",
                objectFit: "cover",
              },
            }}
          >
            <Box
              component="img"
              src={MaamMerz}
              alt="Ma'am Merz"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </Card>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          sx={{
            "& .MuiDialog-paper": {
              width: "500px", // Set the desired width
              borderRadius: "8px", // Adjust corner radius for a rectangular look
            },
          }}
        >
          <DialogTitle sx={{ color: "red" }}>Error</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: "black" }}>
              {error || "An error occurred."}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
